// extracted by mini-css-extract-plugin
module.exports = {"root":"_9e852e","rounded":"_c8a7a8","avatarImg":"_f5acf2"};